import axios from "@util/axios"

class AuthenticationService {
    async login(email, password) {
        return await axios({
            url: `/auth/login/`,
            method: "POST",
            data: {
                email: email,
                password: password,
            },
        })
    }

    async magicLogin(email) {
        return await axios({
            url: `/auth/email/login/`,
            method: "POST",
            data: {
                email: email,
            },
        })
    }

    async signup(email, data = {}) {
        return await axios({
            url: `/auth/email/login/form/`,
            method: "POST",
            data: {
                email: email,
                first_name: data.first_name || null,
                last_name: data.last_name || null,
                company: data.company || null,
            },
        })
    }

    async resetPassword(email) {
        return await axios({
            url: `/auth/password/reset/`,
            method: "POST",
            data: {
                email: email,
            },
            transformResponse: [
                function (data) {
                    const parsedData = JSON.parse(data)

                    parsedData.noToastError = true

                    return JSON.stringify(parsedData)
                },
            ],
        })
    }

    async changePassword(formData) {
        return await axios({
            url:
                formData.uid && formData.token
                    ? `/auth/password/reset/confirm/`
                    : `/auth/password/change/`,
            method: "POST",
            data: {
                old_password: formData.old_password || null,
                new_password1: formData.new_password1 || null,
                new_password2: formData.new_password2 || null,
                ...(formData.uid ? { uid: formData.uid } : null),
                ...(formData.token ? { token: formData.token } : null),
            },
            transformResponse: [
                function (data) {
                    const parsedData = JSON.parse(data)

                    parsedData.noToastError = true

                    return JSON.stringify(parsedData)
                },
            ],
        })
    }

    async logout() {
        return await axios({
            url: `/auth/logout/`,
            method: "POST",
        })
    }

    async approveSignup(uid, key) {
        return await axios({
            url: `/auth/approved/${uid}-${key}/`,
            method: "POST",
            data: {
                uidb36: uid,
                key: key,
            },
        })
    }
}

export default new AuthenticationService()